<template>
  <div class='query-result'>
      <div class="result-title">
          <span>证书验真</span>
      </div>
      <div class="result-content">
        <div class="reason-form">
          <a-form
            ref="ruleForm"
            :model="form"
            :rules="rules"
            >
              <a-form-item ref="userName" label="姓名" name="userName" :label-col="{span:3,offset:5}" :wrapper-col="{span:8}">
                <a-input v-model:value="form.userName" size="large" allow-clear />
              </a-form-item>
              
              <a-form-item label="证书编号" name="certificateNumber" :label-col="{span:3,offset:5}" :wrapper-col="{span:8}">
                <a-input  v-model:value="form.certificateNumber" size="large" allow-clear />
                <a-alert 
                class="alert1"
              v-if="!isCorrect" 
              message="证书编号不存在，请确认" 
              type="error" 
              :after-close="handleClose"
              closable 
              show-icon />
              </a-form-item>
              <a-form-item class="vertify" label="验证码" name="captchaCode" :label-col="{span:2,offset:6}" :wrapper-col="{span:4}">
                <a-input id="vertify" v-model:value="form.captchaCode" size="large" focus allow-clear />
                <div class="vertify-img">
                  <img :src="captcha" alt="" @click="getCaptcha()" style="height:30px;" />
                  <a href.prevent="###" @click="getCaptcha()">看不清楚</a>
                </div>
                <a-alert 
                class="alert2"
                  v-if="!iscaptcha" 
                  message="验证码输入有误，请重新输入" 
                  type="error" 
                  :after-close="handleClose"
                  closable 
                  show-icon />
              </a-form-item>
              <a-form-item :wrapper-col="{offset:11}">
                <a-button type="primary" @click="onSubmit">
                  查询
                </a-button>
              </a-form-item>
              <a-form-item :wrapper-col="{offset:7}">
                <a-alert 
              v-if="false" 
              message="短时间内查询过多[限制10次]" 
              type="error" 
              :after-close="handleClose"
              closable 
              show-icon />
              </a-form-item>
              
            </a-form>
        </div>
      </div>
  </div>
</template>
<script>
import { getUUID,captcha } from "@/request/public";
import { mapGetters,mapActions } from "vuex"
let defaultform = {
  userName:"",
  certificateNumber:"",
  uuid:"",
  captchaCode:"",
}
export default {
  name: '',
  props: {},
  data() {
    return {
      code:[],
      captcha:"",
      form:{
        userName:"",
        certificateNumber:"",
        uuid:"",
        captchaCode:"",
      },
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '请输入您的真实姓名', trigger: 'change' },
        ],
        certificateNumber: [{ required: true, message: '请输入正确证书编号', trigger: 'change' }],
        captchaCode:[{required: true,message: '请输入验证码',trigger: 'blur'}]
      },
    };
  },
  computed: {
    ...mapGetters({
      iscaptcha:"certificate/iscaptcha",
      isCorrect:"certificate/isCorrect",
    })
  },
  watch: {},
  created() {
      this.form.captchaCode = "";
    this.getCaptcha()
  },
  mounted(){
    
  },
  methods: {
    ...mapActions({
         get_check_result:"certificate/get_check_result"
       }),
    async getCaptcha(){
      const res = await getUUID();
      if(res){
      this.form.uuid = res.data.uuid
      }else{
      }
      const result = await captcha(this.form.uuid)
      if(result){
      this.captcha = result.data
      }else{
      }
    },
    onSubmit() {
      const _this = this
      this.$refs.ruleForm
        .validate()
        .then(() => {
          this.get_check_result(this.form)
          .then((res)=>{
            if(res.status == 200 && res.data.examResultList && res.data.examResultList.length!=0){
                _this.$store.commit("certificate/SET_HASRESULT",true)
                _this.$store.commit("certificate/SET_CHECKRESULT",res.data.examResultList)
                _this.$store.commit("certificate/SET_CHECKRESULTIMAGE",res.data.base64)
                
                _this.$store.commit("certificate/SET_ISCORRECT",true)
            }else if(res.status == 200 && res.data.examResultList && res.data.examResultList.length==0){
                _this.$store.commit("certificate/SET_HASRESULT",false)
                _this.$store.commit("certificate/SET_ISCORRECT",false)
                setTimeout(() => {
                    _this.$store.commit("certificate/SET_ISCORRECT",true)
                },2000)
            }else if(res.data.code==500 && res.data.msg == "验证码不正确"){
                _this.$store.commit("certificate/SET_ISCAPTCHA", false)
                setTimeout(() => {
                    _this.$store.commit("certificate/SET_ISCAPTCHA",true)
                },2000)
            }
            if(res.data.code == 500 || res.data.examResultList.length==0){
              _this.getCaptcha()
            }
          })
        })
        .catch(error => {
          _this.getCaptcha()
        });
    },
    callback(key){
    },
  },
  beforeUnmount() {
},
  components: {},
  filters: {},
};
</script>
<style lang='scss' scoped>
.code {
	font-family:Arial,宋体;
	font-style:italic;
	color:green;
	border:0;
	padding:2px 3px;
	letter-spacing:3px;
	font-weight:bolder;
}
.unchanged {
	border:0;
}
.vertify{
  position: relative;
}
.vertify-img{
  position: absolute;
  top: -14px;
  right: -185px;
}
.ant-alert{
  width: 300px;
}
.alert1{
  position: absolute;
  top: -14px;
  right: -320px;
}
.alert2{
  position: absolute;
  top: -14px;
  right: -530px;
}
.result-title{
    font-size: 20px;
    font-weight: bold;
    color: #000;
    height: 54px;
    width: 100%;
    background: #fff;
    box-shadow: 0 0 10px 2px rgba(0,0,0,.05);
    margin-bottom: 36px;
    text-align: center;
    line-height: 54px;
}
.result-content{
  background: #fff;
    padding: 50px 200px;
    display: flex;
    box-shadow: 0 4px 10px 2px rgba(0,0,0,.05);
    background-image: url("../../../assets/circle.svg");
    background-repeat: no-repeat;
    background-position: 100% 100%;
}
.result-content .reason-form{
  margin: auto;
  text-align: left;
  width: 1110px;
  .ant-btn{
    border-radius: 4px;
  }
  .ant-input{
    border-radius: 4px;
  }
  .ant-select{
    border-radius: 4px;

  }
}
.ant-form-item{
  margin-top: 20px;
}

</style>